var JsBarcode = require('jsbarcode')
const processProductLabels = (headers, products, payload, domToAppend) => {
  let getContent = ''
  getContent = `<tr>`
  for (let i = 0; i < headers.length; i++) {
    if (headers[i].value === 'orderedqty' || headers[i].value === 'loc' || headers[i].value === 'receivedqty') {
      getContent += `<th class="text-right">${headers[i].text}</th>`
    } else {
      getContent += `<th>${headers[i].text}</th>`
    }
  }
  getContent += `</tr>`
  for (let i = 0; i < products.length; i++) {
    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('id', `product_${i}`)
    svg.setAttribute('class', 'product-barcodes')
    domToAppend.appendChild(svg)
    let getBarcode = ''
    if (products[i].productnumberbarcode) {
      let code = JsBarcode(`#product_${i}`, products[i].productnumberbarcode, { height: 37, textAlign: 'center', fontSize: 15 })
      getBarcode = code._renderProperties[0].element.outerHTML
    }
    getContent += '<tr>'
    getContent += `<td class="th-fontsize">${getBarcode}</td>`
    getContent += `<td class="th-fontsize" style="vertical-align: middle;">${products[i]['productname'] || ''}</td>`
    if (products[i].locations && products[i].locations.length > 0) {
      getContent += `<td class="th-fontsize text-right" style="vertical-align: middle;">`
      for (let j = 0; j < products[i].locations.length; j++) {
        getContent += `${products[i].locations[j]['name'] || ''} <br />`
      }
      getContent += `</td>`
    } else {
      getContent += `<td class="text-right" style="vertical-align: middle;">${payload.labels.noLoc}</td>`
    }
    getContent += `<td class="th-fontsize text-right" style="vertical-align: middle;">${products[i]['orderedqty'] || ''}</td>`
    if (products[i].locations && products[i].locations.length > 0) {
      getContent += `<td class="th-fontsize text-right" style="vertical-align: middle;">`
      for (let j = 0; j < products[i].locations.length; j++) {
        getContent += `${products[i].locations[j]['receivedqty'] || '0'} <br />`
      }
      getContent += `</td>`
    } else {
      getContent += `<td class="th-fontsize text-right" style="vertical-align: middle;">${products[i]['receivedqty'] || '0'}</td>`
    }
    getContent += `<td class="th-fontsize" style="vertical-align: middle;">${products[i]['isbatch'] ? 'Y' : 'N'}</td>`
    getContent += '</tr>'
  }
  let orderSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  orderSvg.setAttribute('id', `order_barcode`)
  orderSvg.setAttribute('class', 'barcodes')
  domToAppend.appendChild(orderSvg)
  let getOrderBarcode = ''
  if (payload.values.number) {
    let code = JsBarcode(`#order_barcode`, payload.values.number, { height: 35, textAlign: 'center', fontSize: 14, displayValue: false })
    getOrderBarcode = code._renderProperties[0].element.outerHTML
  }
  return content(getContent, payload, getOrderBarcode)
}
const content = (content, payload, getOrderBarcode) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
      tbody tr { page-break-inside:avoid; }
      tbody tr td { word-break: break-word; }
      .product-barcodes { margin-bottom: 30px; }
      .table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th {
        padding: 2.5px !important;
      }
    </style>
  </head>
  <body>
  <div class="row">
    <div class="col-xs-6">
      ${getOrderBarcode}
    </div>
    <div class="col-xs-6">
      <img class="img-responsive pull-right" height="180" width="180" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
    </div>
  </div>
  <div class="row">
    <div class="col-xs-8">
      <div class="col-xs-3">
        ${payload.labels.order}: ${payload.values.number}
      </div>
      <div class="col-xs-9">
      ${payload.labels.supplier}: ${payload.values.supplier}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <table class="table table-condensed" style="width: 100%">
        <tbody>
          ${content}
        </tbody>
      </table>
    </div>
  </div>
  </body>
</html>`)))
export default processProductLabels
